export default __webpack_public_path__ + "static/media/kodekloud.85778a7b.jpg";